import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appPreventSomeSpecialCharacters]',
    standalone: false
})
export class PreventSomeSpecialCharactersDirective {
  private preventQuote = /["<>]/;
  private special = /[<>]/;
  private allowParenthesisWithoutQuote = /["<>]/;

  @Input() allowQuote;
  @Input() allowParenthesis;

  constructor(private eleRef: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.checkValidation(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) 
  onPaste(event: ClipboardEvent) {
    if (this.checkValidation(event.clipboardData.getData('text/plain'))) {
      event.preventDefault();
    }
  }

  checkValidation(text: string): boolean {
    if(this.allowQuote == 'no' && this.allowParenthesis == 'yes') {
      return this.allowParenthesisWithoutQuote.test(text);
    } else if(this.allowQuote == 'yes' ) {
      return this.special.test(text);
    } else {
      return this.preventQuote.test(text);
    }
  }

}